export default __webpack_public_path__ + "images/d496904ef6b1264a0a7f769d33acad73-4_tablet_1067x470.webp";